export const mapSizesTitle: Record<string, string[]> = {
    "Extra Large": ["mobileHeading1", "desktopHeading1"],
    Large: ["mobileHeading2", "desktopHeading2"],
};

export const mapSizesDescription: Record<string, string[]> = {
    Normal: ["mobileBodyB2", "desktopBodyB2"],
    Large: ["mobileBodyB1", "desktopBodyB1"],
};
